import { render, staticRenderFns } from "./EmployeeDetailSection.vue?vue&type=template&id=6d2b7916&scoped=true"
import script from "./EmployeeDetailSection.vue?vue&type=script&lang=js"
export * from "./EmployeeDetailSection.vue?vue&type=script&lang=js"
import style0 from "./EmployeeDetailSection.vue?vue&type=style&index=0&id=6d2b7916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2b7916",
  null
  
)

export default component.exports